<template>
  <div class="container-fluid">
    <div>
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h4 class="panel-title">
                <span class="title">Cadastro de URLs.</span>
                <br />
                <span class="navigation">Cadastros > URL</span>
              </h4>
            </div>
          </div>
        </div>
        <div class="card-body">
          <form name="form" @submit.prevent="onSubmit">
            <div class="row">
              <div class="col-md-4 mb-2">
                <label for="tipo">Tipo de Menu:</label>
                <span class="p-fluid">
                  <Dropdown id="tipo" v-model="selectedTipo" :options="tipos" optionLabel="name"
                    :optionDisabled="desabilitarEdicao" :disabled="desabilitarEdicao" placeholder="Selecione um Tipo"
                    @change="onTipoChange" />
                </span>
              </div>

              <div class="col-md-4 mb-2" v-if="this.selectedTipo.key !== 'M'">
                <label for="menuPrincipal">Menu Principal:</label>
                <span class="p-fluid">
                  <Dropdown id="menuPrincipal" v-model="selectedMenuPrincipal" :options="menusPrincipal"
                    optionLabel="menu" placeholder="Selecione um Menu Principal" />
                </span>
              </div>

              <div class="col-md-4 mb-2" v-if="this.selectedTipo.key !== 'M'">
                <label for="tipoUrl">Tipo de URL:</label>
                <span class="p-fluid">
                  <Dropdown id="tipoUrl" v-model="selectedTipoUrl" :options="tiposUrl" optionLabel="name"
                    placeholder="Selecione o Tipo da URL" />
                </span>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4 mb-2 col-sm-12">
                <label for="nome">Nome:</label>
                <span class="p-fluid">
                  <InputText type="text" id="nome" v-model="url.menu" />
                </span>
              </div>
              <div class="col-md-8 mb-2 col-sm-12" v-if="this.selectedTipo.key !== 'M'">
                <label for="nome">URL:</label>
                <span class="p-fluid">
                  <InputText type="text" id="nome" v-model="url.url" />
                </span>
              </div>
            </div>

            <div class="row pt-3">
              <DataTable :value="tiposPerfil" :paginator="true" :rows="10" class="p-datatable-responsive"
                :autoLayout="true">
                <template #header>
                  <div class="p-clearfix">Perfis de Usuário onde será exibido o Menu ou URL</div>
                </template>
                <Column headerStyle="width: 3%" field="selecionado" header>
                  <template #body="slotProps">
                    <Checkbox v-model="slotProps.data.selecionado" :binary="true" />
                  </template>
                </Column>
                <Column field="nome" header="Nome"></Column>
              </DataTable>
            </div>

            <hr />
            <template>
              <Button label="Gravar" title="Gravar" type="submit" class="p-button-primary mr-2 p-button-success"
                icon="pi pi-check" :disabled="loading">
              </Button>
              <router-link to="/urlConsulta">
                <Button label="Voltar" title="Voltar" type="button" class="p-button-primary mr-2"
                  icon="pi pi-arrow-left" :disabled="loading"></Button>
              </router-link>
            </template>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LoginService from "../services/acesso/login.service";
import UrlService from "../services/nfse/url.service";
import PerfilService from "../services/nfse/perfil.service";
import Url from "../models/nfse/Url";

export default {
  name: "urlCadastro",
  data() {
    return {
      currentUser: null,
      loading: false,
      url: new Url(),
      menusPrincipal: [],
      selectedMenuPrincipal: null,
      selectedTipoUrl: null,
      tiposUrl: [
        { name: 'Link Externo', key: 'E' },
        { name: 'BI GPI', key: 'G' }
      ],
      tiposPerfil: [],
      selectedPerfil: null,
      tipos: [
        { name: 'Menu Principal', key: 'M' },
        { name: 'Item de Menu', key: 'I' }
      ],
      selectedTipo: null,
      erros: []
    };
  },
  created() {
    this.currentUser = LoginService.currentUserValue;
    this.selectedTipo = this.tipos[0];
    this.selectedTipoUrl = this.tiposUrl[0];
    this.getTiposPerfil();
    this.getMenusPrincipal();

    this.urlId = this.$route.params.id;

    if (this.urlId != null) {
      setTimeout(async () => {
        await UrlService.get(this.urlId).then(
          response => {
            this.url = response.data;

            this.selectedTipo = this.tipos.find(tipo => tipo.key === (this.url.idPaginaPai ? 'I' : 'M'));

            this.selectedTipoUrl = this.tiposUrl.find(tipo => tipo.key === this.url.tipoUrl);

            if (this.url.idPaginaPai) {
              this.selectedMenuPrincipal = this.menusPrincipal.find(menu => menu.id === this.url.idPaginaPai.id);
            }

            this.tiposPerfil.forEach(tipo => {
              tipo.selecionado = this.url.perfis.some(perfil => perfil.id === tipo.id);
            });
          },
          error => {
            let errorMessage = "Houve um problema ao buscar a URL!";
            if (error.response) {
              errorMessage = error.response.data;
            }
            this.$toast.add({
              severity: "error",
              summary: errorMessage
            });
          });
      }, 250);
    }
  },
  methods: {
    getTiposPerfil() {
      PerfilService.findAllByFiltro(this.currentUser.usuario.idCliente, '').then(
        data => {
          this.tiposPerfil = data.data.map(tipo => ({ ...tipo, selecionado: false }));
        }
      )
    },
    //
    getMenusPrincipal() {
      UrlService.findAllPrincipalByFiltro(this.currentUser.usuario.idCliente, '').then(
        data => {
          this.menusPrincipal = data.data
        }
      )
    },
    onSubmit() {
      this.loading = true;

      //Atribuir dados ao objeto a ser salvo
      this.url.idCliente = this.currentUser.usuario.idCliente;

      if (this.selectedTipo.key === 'I') {
        console.log(this.selectedMenuPrincipal);
        if (this.selectedMenuPrincipal) {
          this.url.idPaginaPai = this.selectedMenuPrincipal;
        }

        if (this.selectedTipoUrl) {
          this.url.tipoUrl = this.selectedTipoUrl.key;
        }
      } else {
        this.url.idPaginaPai = null;
        this.url.tipoUrl = null;
      }

      this.url.perfis = this.tiposPerfil;

      this.validar();

      if (this.erros.length > 0) {
        this.$root.$emit("alert:warn", this.erros[0]);
      } else {
        this.salvar();
      }

      this.loading = false;
    },
    validar() {
      this.erros = [];
      if (!this.url.menu) {
        this.erros.push("Campo \"Nome\" é de preenchimento obrigatório!");
      }
      if (this.selectedTipo.key === 'I' && !this.url.url) {
        this.erros.push("Campo \"URL\" é de preenchimento obrigatório!");
      }
      if (this.selectedTipo.key === 'I' && !this.url.idPaginaPai) {
        this.erros.push("Campo \"Menu Principal\" é de preenchimento obrigatório!");
      }
    },
    salvar() {
      UrlService.save(this.url).then(
        data => {
          console.log(data);
          this.$root.$emit("alert:success", "URL salva com sucesso!");
          this.$router.push("urlConsulta");
        },
        error => {
          let errorMessage = "Houve um problema ao salvar a URL!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$root.$emit("alert:error", errorMessage);
        }
      );
    },
    onTipoChange() {
      if (this.selectedTipo.key === 'M') {
        this.url.nome = null;
        this.url.url = null;
      }
    }
  },
  computed: {
    desabilitarEdicao() {
      return this.url !== null && this.url.id !== null
    }
  }
}

</script>

<style scoped></style>
